/**
 * Resolución de selección del lienzo usando únicamente el contrato público del model.
 */
import type { UppKonvaArea, UppKonvaShape } from '@unpispas/upp-konva';

export function demoResolveAreaShapeById(area: UppKonvaArea, id: string): UppKonvaShape | null {
  return area.findShapeById(id);
}
